import { API_PATH } from '../../routes/managePath';

export const CUSTOMER_MANAGEMENT_PATH = {
  INDEX: API_PATH.CUSTOMER_MANAGEMENT,
};
